const homepage = {
  path: 'homepage',
  component: resolve => require(['../../../../components/pages/user/homepage'], resolve)
}

export default homepage
